/*
 * @Author: libo 
 * @Date: 2020-11-13 16:54:37 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-08 12:32:30
 */

<template>
  <a-modal v-model="visible" :title="title" :width="width" switchFullscreen :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <div class="">
      <detail-list :col="2">
        <detail-list-item :term="$t('用户编号')">{{model.meterUserId}}</detail-list-item>
        <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
        <detail-list-item :term="$t('手机号码')">{{model.userPhone}}</detail-list-item>
        <detail-list-item :term="$t('用户地址')">{{model.userAddr}}</detail-list-item>
        <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
        <detail-list-item :term="$t('用水单价(元)')">{{model.userPriceTotal?model.userPriceTotal: ''}}</detail-list-item>
        <detail-list-item :term="$t('价格名称')">{{model.userPriceName}}</detail-list-item>
        <detail-list-item :term="$t('购买金额(元)')">{{model.userPayAccountNum}}</detail-list-item>
        <detail-list-item :term="$t('购买量(m³)')">{{model.payWaterNum}}</detail-list-item>
        <detail-list-item :term="$t('操作类型')">{{payTypeObj[model.userAccountPayType]?$t(payTypeObj[model.userAccountPayType]):''}}</detail-list-item>
        <detail-list-item :term="$t('缴费途径')">{{payWayObj[model.payWay]?$t(payWayObj[model.payWay]):''}}</detail-list-item>
        <detail-list-item :term="$t('备注')" :itemCol="1">{{model.payRemark}}</detail-list-item>
      </detail-list>
    </div>
  </a-modal>
</template>

<script>

  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {payWayObj,payTypeObj} from '@/utils/constants/commonConstant'

  export default {
    name: 'MeterParticularsModal',
    components: {
      DetailList,
      DetailListItem,
    },
    data () {
      return {
        title:'',
        payWayObj,
        payTypeObj,
        width:600,
        visible: false,
        disableSubmit: false,
        model: {}
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          
        })
      },
      edit (record) {
        this.visible=true
        this.model = Object.assign({},record)
      },
      handleOk () {
        
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel () {
        this.close();
      },
    }
  }
</script>
<style scoped>
.detail-list >>> .content{
  line-height: normal;
}
</style>